export const SDK_VERSION = '8.35.0';
